import { render, staticRenderFns } from "./bespoke.vue?vue&type=template&id=1d1b0752&scoped=true&"
import script from "./bespoke.vue?vue&type=script&lang=js&"
export * from "./bespoke.vue?vue&type=script&lang=js&"
import style0 from "./bespoke.vue?vue&type=style&index=0&id=1d1b0752&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1b0752",
  null
  
)

export default component.exports